// extracted by mini-css-extract-plugin
export default {"layout":"N4yuLHnu2bQ1TszqtEyM"};